/**
 * Utilitário para cache de dados no localStorage
 */

export class CacheUtil {
  /**
   * Salva produtos no cache
   */
  static saveProdutosCache(
    tipo: 'previsao' | 'pedido',
    idClassificacao: string,
    produtos: any[]
  ): void {
    try {
      const key = `produtos-${tipo}-${idClassificacao}`;
      const cacheData = {
        produtos,
        timestamp: Date.now(),
      };
      localStorage.setItem(key, JSON.stringify(cacheData));
    } catch (error) {
      console.error('Erro ao salvar cache de produtos:', error);
    }
  }

  /**
   * Carrega produtos do cache
   */
  static loadProdutosCache(
    tipo: 'previsao' | 'pedido',
    idClassificacao: string,
    maxAge: number = 30 * 60 * 1000 // 30 minutos padrão
  ): any[] | null {
    try {
      const key = `produtos-${tipo}-${idClassificacao}`;
      const cached = localStorage.getItem(key);

      if (!cached) return null;

      const cacheData = JSON.parse(cached);
      const age = Date.now() - cacheData.timestamp;

      // Se o cache está expirado, remove e retorna null
      if (age > maxAge) {
        localStorage.removeItem(key);
        return null;
      }

      return cacheData.produtos;
    } catch (error) {
      console.error('Erro ao carregar cache de produtos:', error);
      return null;
    }
  }

  /**
   * Limpa todo o cache de produtos de um tipo específico
   */
  static clearProdutosCache(tipo: 'previsao' | 'pedido'): void {
    try {
      const keys = Object.keys(localStorage);
      const prefix = `produtos-${tipo}-`;

      keys.forEach(key => {
        if (key.startsWith(prefix)) {
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.error('Erro ao limpar cache de produtos:', error);
    }
  }

  /**
   * Limpa todo o cache de produtos (previsão e pedido)
   */
  static clearAllProdutosCache(): void {
    this.clearProdutosCache('previsao');
    this.clearProdutosCache('pedido');
  }

  /**
   * Invalida cache de uma classificação específica
   */
  static invalidateProdutosCache(
    tipo: 'previsao' | 'pedido',
    idClassificacao: string
  ): void {
    try {
      const key = `produtos-${tipo}-${idClassificacao}`;
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Erro ao invalidar cache:', error);
    }
  }

  /**
   * Verifica se existe cache válido
   */
  static hasProdutosCache(
    tipo: 'previsao' | 'pedido',
    idClassificacao: string,
    maxAge: number = 30 * 60 * 1000
  ): boolean {
    const cached = this.loadProdutosCache(tipo, idClassificacao, maxAge);
    return cached !== null && cached.length > 0;
  }
}
